import React from 'react';
import RnFArticle from './RnFArticle';
import RnFEatery from './RnFEatery';
import RnFExperience from './RnFExperience';
import HorizontalSlider from './HorizontalSlider';
import VerticalSlider from './VerticalSlider';
import { shuffle } from 'utils/';

const CardsSlider = ({ cards, call, history, noslider, noshuffle, curatedBy }) => {
  let displayCards = [];
  cards = noshuffle ? cards : shuffle(cards);
  cards.map((card, i) => {
    switch (card.resourceType) {
      case 'LISTICLE':
        displayCards.push(
          <RnFArticle
            key={'card' + i}
            name={card.title}
            summary={card.description}
            img={card.imageUrl}
            data={card}
          />
        );
        return 0;
      case 'EATERY':
        displayCards.push(
          <RnFEatery
            key={'card' + i}
            name={card.title}
            img={card.imageUrl}
            location={card.location}
            cuisine={card.cuisines}
            dishes={card.mustTryDishes}
            desc={card.description}
            data={card}
          />
        );
        return 0;
      case 'STORY':
        displayCards.push(
          <RnFArticle
            key={'card' + i}
            name={card.title}
            curatedBy={curatedBy}
            cuisine={card.cuisines}
            location={card.location}
            summary={card.description}
            img={card.imageUrl}
            data={card}
            desc={card.description}
          />
        );
        return 0;
      case 'EXPERIENCE':
        displayCards.push(
          <RnFExperience
            key={'card' + i}
            name={card.name}
            expType={card.experienceType.name}
            summary={card.description ? card.description : card.about}
            img={card.mainImage.uri ? card.mainImage.uri : '/img/na.png'}
          />
        );
        return 0;
      default:
        return 0;
    }
  });
  if (noslider) return <VerticalSlider>{displayCards}</VerticalSlider>;
  else return <HorizontalSlider>{displayCards}</HorizontalSlider>;
};

export default CardsSlider;
